<template>
  <div v-if="preloader === true">
    <template>
      <div
        class="d-flex align-center justify-center flex-column"
        style="height: 100vh"
      >
        <bubble-loader />
      </div>
    </template>
  </div>
  <div v-else>
    <v-card
      height="64px"
      width="100%"
      class="background ml-4 mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
      style="
        position: fixed;
        z-index: 200;
        top: 0;
        width: 98%;
        padding-top: 16px;
      "
    >
      <v-card-title class="ml-0 pl-0">
        <p class="breadcrumb-text">Candidate List</p>
        <span><v-icon class="breadcrumb-arrow">mdi-chevron-down</v-icon></span>
      </v-card-title>
      <UserNavMenu />
    </v-card>
    <v-container fluid class="qpad pb-0 px-8">
      <!-- Header Actions -->
      <v-row class="justify-space-between mr-5" max-width="366px" persistent>
        <v-col class="pl-5" cols="3">
          <div class="text-h6">Candidate List</div>
        </v-col>
        <v-col cols="9" class="mt-0 p-0">
          <v-row class="justify-end align-center">
            <!-- Search -->
            <v-text-field
              solo
              label="Search here..."
              prepend-inner-icon="mdi-magnify"
              v-model="searchValue"
              hide-details
              class="search-bar border-button rounded-pill mx-2"
              dense
              clearable
            ></v-text-field>

            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="btn outline-btn elevation-0 mx-2 pl-4 pr-6"
                  rounded
                  depressed
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-img
                    v-bind="attrs"
                    v-on="on"
                    :src="require(`@/assets/svg/sort.svg`)"
                  />
                  <span>Sort</span>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="option in sortOptions"
                  :key="option.value"
                  @click="selectSortOption(option.value)"
                  :class="{
                    'selected-sort-option': selectedSort === option.value,
                  }"
                >
                  <v-list-item-title>
                    {{ option.label }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>

            <!-- Filter Button -->
            <!-- <v-btn
            depressed
            rounded
            outlined
            class="btn outline-btn mx-2 pl-4 pr-6"
          >
            <v-icon class="pr-2">mdi-tune</v-icon>
            <span>Filter</span>
          </v-btn> -->

            <!-- Export Button -->
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-btn
                  depressed
                  outlined
                  rounded
                  class="btn outline-btn mx-2"
                  :loading="downloadLoading"
                  :disabled="downloadableCandidates.length === 0"
                  @click="downloadCandidates"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-import mdi-rotate-90</v-icon>
                </v-btn>
              </template>

              <span>Download</span>
            </v-tooltip>
          </v-row>
        </v-col>
      </v-row>

      <!-- Status Tabs -->
      <v-row justify="space-between" class="mr-0 pr-4">
        <v-col class="pl-5 pt-0" cols="12">
          <v-chip-group mandatory v-model="currentSelectedStatus">
            <v-chip
              v-for="(filter, index) in visibleStatusFilters"
              :key="filter.key"
              class="mr-4"
              :color="currentSelectedStatus === index ? 'active-chip' : ''"
            >
              {{ filter.label }} ({{ statusCounts[filter.key] }})
            </v-chip>
          </v-chip-group>
        </v-col>
      </v-row>

      <!-- Assessment Table -->
      <v-card class="mt-6">
        <v-data-table
          :headers="headers"
          :items="filteredCandidates"
          :search="searchValue"
          :options.sync="options"
          :loading="loadingTable"
          class="elevation-1"
          hide-default-footer
          ref="myTable"
          :class=" isScrollable ? 'frozen-columns-table' : ''"
        >
          <template v-slot:loading>
            <bubble-loader />
          </template>
          <template v-slot:[`item.name`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span class="widened-multi-line-ellipsis cursor" v-bind="attrs" v-on="on"> {{ item.name }} </span>
              </template>
              <span> {{ item.name }} </span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.email`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span class="widened-multi-line-ellipsis cursor" v-bind="attrs" v-on="on"> {{ item.email }} </span>
              </template>
              <span> {{ item.email }} </span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-chip :class="candidateStatusMeta(item.status).chipClass">
              {{ candidateStatusMeta(item.status).label }}
            </v-chip>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex justify-center">
              <v-menu left bottom offset-x offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-if="$featureFlags.isEnabled('hiring_manager_hierarchy')"
                    :disabled="!canConfirmAvailability(item)"
                    @click="openConfirmAvailability(item)"
                  >
                    <v-list-item-title>Confirm Availability</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    :disabled="!canTakeDecision(item)"
                    @click="navigateToUserReport(item)"
                  >
                    <v-list-item-title>Take Decision</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    :disabled="!canViewResponse(item)"
                    @click="navigateToUserReport(item)"
                  >
                    <v-list-item-title>View Response</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </template>

          <template v-slot:item.languages="{ item }">
            {{ item.availableLanguages.join(", ") }}
          </template>
          <template v-slot:item.round="{ item }">
            Round {{ item.round }}
          </template>
          <template v-slot:item.subjects="{ item }">
            <div  class="my-custom-tooltip">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on">
                    {{ item?.subjects[0] }}
                    {{
                      item.subjects.length > 1
                        ? `+${item.subjects.length - 1}`
                        : ""
                    }}
                  </span>
                </template>
               <span
                  v-for="(sub, index) in item.subjects"
                  :key="index"
                  :class="item.subjects.length > 1 ? 'custom-tooltip' : ''"
                >
                  {{ sub }}
                </span>
              </v-tooltip>
            </div>
          </template>
             <template v-slot:item.screeningTotal="{ item }">
            {{ item.numberOfRounds?.includes('screening') ? item.screeningTotal : 'NA' }}
          </template>
          <template v-slot:item.mainsTotal="{ item }">
            {{ item.numberOfRounds?.includes('mains') ? item.mainsTotal : 'NA' }}
          </template>
          <template v-slot:item.demoScore="{ item }">
            {{ item.numberOfRounds?.includes('demo') ? item.demoScore.toFixed(2) || 0 : 'NA'}}
          </template>
          <template v-slot:item.interviewScore="{ item }">
            {{item.numberOfRounds?.includes('interview') ?  (typeof item.interviewScore === 'number' ? item.interviewScore.toFixed(2) : item.interviewScore) : 'NA' }}
          </template>
          <template v-slot:footer="{ props }">
            <table-footer
              :pagination="props.pagination"
              :options="props.options"
              @update-options="onFooterUpdate"
            />
          </template>
        </v-data-table>
      </v-card>

      <!-- Confirm Availability dialog (mirrors the interviewee-list flow) -->
      <v-dialog
        v-if="confirmAvailabilityDialog"
        v-model="confirmAvailabilityDialog"
        max-width="700px"
        persistent
      >
        <v-card class="px-6 pt-6 pb-6">
          <p class="text-h6">Confirm Availability</p>
          <div class="d-flex justify-space-between align-center">
            <div class="d-flex flex-column" style="max-width: 340px">
              <div class="font-weight-medium">
                My Availability <span class="red--text">*</span>
              </div>
              <div class="grey--text text--darken-1 caption" v-if="currentCandidate?.canConfirmAvailability">
                Choose an option to confirm your availability to submit your
                decision for the candidate.
              </div>
              <div class="grey--text text--darken-1 caption" v-else>
               You have been assigned as the hiring manager for this interview. This assignment is mandatory and cannot be declined.
              </div>
            </div>
            <v-radio-group
              v-model="availabilityRadio"
              row
              hide-details
              class="ma-0 pa-0 availability-radio-group"
            >
              <v-radio label="Yes" value="yes" class="ma-0 mr-8"></v-radio>
              <v-radio label="No" value="no" class="ma-0" :disabled="!currentCandidate?.canConfirmAvailability"></v-radio>
            </v-radio-group>
          </div>
          <div class="d-flex justify-end mt-4">
            <v-btn
              class="btn outline-btn elevation-0 mx-2 px-3"
              rounded
              depressed
              @click="closeConfirmAvailabilityDialog"
              >Cancel</v-btn
            >
            <v-btn
              rounded
              class="btn primary-btn elevation-0 mx-2 px-3"
              :disabled="!availabilityRadio"
              :loading="availabilitySubmitting"
              @click="submitAvailability"
              >Submit</v-btn
            >
          </div>
        </v-card>
      </v-dialog>

      <!-- Response submitted success dialog -->
      <v-dialog v-model="responseSubmittedDialog" max-width="400px">
        <v-card class="candidate-success-popup pa-6">
          <div class="d-flex align-center flex-column">
            <img class="cursor" width="96px" height="96px" src="../assets/success.svg" />
            <p class="candidate-success-popup--text">
              <span>Response Submitted Successfully</span>
            </p>
            <p>
              <v-btn class="btn primary-btn px-16" @click="closeResponseSubmitted"
                >Ok</v-btn
              >
            </p>
          </div>
        </v-card>
      </v-dialog>

      <v-snackbar v-model="availabilitySnackbar" :timeout="3000" color="error">
        {{ availabilityError }}
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import "../styles.css";
import Papa from "papaparse";
import CampaignController from "@/controllers/CampaignController";
import UserNavMenu from "@/components/UserNavMenu.vue";
import BubbleLoader from "@/components/BubbleLoader.vue";
import isTableScrollableMixin from "@/mixins/isTableScrollableMixin";

export default {
  components: {
    UserNavMenu,
    BubbleLoader,
  },
  mixins: [isTableScrollableMixin],
  name: 'candidateList',
  data() {
    return {
      preloader: true,
      candidates: [],
      searchValue: "",
      currentSelectedStatus: 0,
      statusFilters: [
        { key: "ALL", label: "All" },
        { key: "INVITED", label: "Invited" },
        { key: "AVAILABLE", label: "Available" },
        { key: "NOT_AVAILABLE", label: "Not Available" },
        { key: "YET_TO_DECIDE", label: "Yet To Take Decision" },
        { key: "DECISION_DONE", label: "Decision Done" },
      ],
      statusConfig: {
        INVITED: { label: "Invited", chipClass: "invited-status" },
        AVAILABLE: { label: "Available", chipClass: "available-status" },
        NOT_AVAILABLE: { label: "Not Available", chipClass: "not-available-status" },
        YET_TO_DECIDE: { label: "Yet To Take Decision", chipClass: "yet-to-decide-status" },
        DECISION_DONE: { label: "Decision Done", chipClass: "decision-done-status" },
      },
      confirmAvailabilityDialog: false,
      responseSubmittedDialog: false,
      availabilityRadio: "",
      availabilitySubmitting: false,
      availabilitySnackbar: false,
      availabilityError: "",
      currentCandidate: {},
      headers: [
        { text: "Name", value: "name", align: "start" },
        { text: "Email Id", value: "email", align: "start" },
        { text: "Level", value: "level", align: "center" },
        { text: "Interview Round", value: "round", align: "center" },
        { text: "Subject", value: "subjects", align: "center" },
        { text: "Screening", value: "screeningTotal", align: "center" },
        { text: "Mains", value: "mainsTotal", align: "center" },
        { text: "Demo", value: "demoScore", align: "center" },
        { text: "Interview", value: "interviewScore", align: "center" },
        { text: "Status", value: "status", align: "center" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      selectedSort: "dateNewest", // Default selected sort option
      sortOptions: [
        { value: "nameAsc", label: "Name - Ascending (A-Z)" },
        { value: "nameDesc", label: "Name - Descending (Z-A)" },
        { value: "dateNewest", label: "Date - Newest" },
        { value: "dateOldest", label: "Date - Oldest" },
      ],
      sortOrder: "desc",
      sortCol: "updatedOn",
      options: { page: 1, itemsPerPage: 10 },
      loadingTable: true,
      downloadLoading: false,
    };
  },
  computed: {
    // Invited / Available / Not Available only exist once the hiring-manager
    // hierarchy flow is live. With the flag off the list falls back to the
    // pre-hierarchy set (All / Yet To Take Decision / Decision Done).
    visibleStatusFilters() {
      if (this.$featureFlags.isEnabled("hiring_manager_hierarchy")) {
        return this.statusFilters;
      }
      const hierarchyOnlyKeys = ["INVITED", "AVAILABLE", "NOT_AVAILABLE"];
      return this.statusFilters.filter(
        (filter) => !hierarchyOnlyKeys.includes(filter.key)
      );
    },
    statusCounts() {
      const counts = {
        ALL: this.candidates.length,
        INVITED: 0,
        AVAILABLE: 0,
        NOT_AVAILABLE: 0,
        YET_TO_DECIDE: 0,
        DECISION_DONE: 0,
      };
      this.candidates.forEach((candidate) => {
        const key = this.resolveCandidateStatusKey(candidate.status);
        counts[key] = (counts[key] || 0) + 1;
      });
      return counts;
    },
    filteredCandidates() {
      const selectedFilter = this.visibleStatusFilters[this.currentSelectedStatus];
      if (!selectedFilter || selectedFilter.key === "ALL") {
        return this.candidates;
      }
      return this.candidates.filter(
        (candidate) =>
          this.resolveCandidateStatusKey(candidate.status) === selectedFilter.key
      );
    },
    downloadableCandidates() {
      const searchTerm = this.searchValue.trim().toLowerCase();

      if (!searchTerm) {
        return this.filteredCandidates;
      }

      return this.filteredCandidates.filter((candidate) => {
        const searchableValues = [
          candidate.name,
          candidate.email,
          candidate.level,
          candidate.round,
          this.candidateStatusMeta(candidate.status).label,
          ...(candidate.subjects || []),
          ...(candidate.availableLanguages || []),
          candidate.numberOfRounds?.join(", "),
          candidate.screeningTotal,
          candidate.mainsTotal,
          candidate.demoScore,
          candidate.interviewScore,
        ];

        return searchableValues
          .filter((value) => value !== undefined && value !== null)
          .some((value) => String(value).toLowerCase().includes(searchTerm));
      });
    },
  },
  methods: {
    onFooterUpdate(newOptions) {
      this.options = { ...this.options, ...newOptions };
    },
    async fetchCandidates() {
      try {
        this.loadingTable = true;
        const adminId =  this.$store.state.userInfo.id;
        const response = await CampaignController.fetchCandidates(
          adminId,
          this.sortCol,
          this.sortOrder
        );

        if (response.data.flag) {
          console.log("API Response:", response.data);
          this.candidates = response.data.candidates;
        } else {
          console.error(response.data.message);
        }
      } catch (error) {
        console.error("Error fetching candidates:", error);
      } finally {
        this.preloader = false;
        this.loadingTable = false;
      }
    },
    formatCandidateDecisionStatus(status) {
      return this.candidateStatusMeta(status).label;
    },
    resolveCandidateStatusKey(status) {
      switch (status) {
        case "INVITED":
          return "INVITED";
        case "AVAILABLE":
          return "AVAILABLE";
        case "NOT_AVAILABLE":
        case "UNAVAILABLE":
          return "NOT_AVAILABLE";
        case "SEND_TO_HIRING_MANAGER":
          return "YET_TO_DECIDE";
        default:
          return "DECISION_DONE";
      }
    },
    candidateStatusMeta(status) {
      return this.statusConfig[this.resolveCandidateStatusKey(status)];
    },
    canConfirmAvailability(item) {
      return item.status === "INVITED"
    },
    canTakeDecision(item) {
      return (
        item.status === "SEND_TO_HIRING_MANAGER" &&
        !!this.$store.state.role.candidatesListing.create
      );
    },
    canViewResponse(item) {
      return this.resolveCandidateStatusKey(item.status) === "DECISION_DONE";
    },
    openConfirmAvailability(item) {
      if (!this.canConfirmAvailability(item)) {
        return;
      }
      this.currentCandidate = item;
      this.availabilityRadio = "";
      this.confirmAvailabilityDialog = true;
    },
    closeConfirmAvailabilityDialog() {
      this.confirmAvailabilityDialog = false;
      this.currentCandidate = {};
      this.availabilityRadio = "";
    },
    async submitAvailability() {
      if (!this.availabilityRadio) {
        return;
      }
      try {
        this.availabilitySubmitting = true;
        const res = await CampaignController.hiringManagerAvailability({
          campaignId: this.currentCandidate.campaignId,
          userId: this.currentCandidate.userId,
          round: this.currentCandidate.round,
          level: this.currentCandidate.level,
          hmEmail: this.$store.state.userInfo.email,
          response: this.availabilityRadio === "yes" ? "AVAILABLE" : "UNAVAILABLE",
        });
        if (res && res.data && res.data.flag) {
          this.confirmAvailabilityDialog = false;
          this.responseSubmittedDialog = true;
          await this.fetchCandidates();
        } else {
          this.availabilityError =
            res?.data?.message || "Something went wrong. Please try again.";
          this.availabilitySnackbar = true;
        }
      } catch (error) {
        console.error("Error confirming candidate availability:", error);
        this.availabilityError = "Something went wrong. Please try again.";
        this.availabilitySnackbar = true;
      } finally {
        this.availabilitySubmitting = false;
      }
    },
    closeResponseSubmitted() {
      this.responseSubmittedDialog = false;
      this.currentCandidate = {};
      this.availabilityRadio = "";
    },
    formatCandidateDecision(candidate) {
      const finalStatus = candidate?.interviewFinalStatus?.status || candidate?.finalStatus || candidate?.status;
      const finalRound =
        candidate?.interviewFinalStatus?.round ||
        candidate?.finalRound ||
        candidate?.round;

      switch (finalStatus) {
        case "ACCEPT":
          return "Accepted";
        case "REJECT":
          return finalRound ? `Rejected at R${finalRound}` : "Rejected";
        case "ROUND_ACCEPTED":
          return finalRound ? `Accepted at R${finalRound}` : "Accepted";
        case "ONHOLD":
          return "On Hold";
        case "SEND_TO_HIRING_MANAGER":
          return "Pending";
        default:
          return candidate?.candidateDecision || "NA";
      }
    },
    formatCandidateRoundScore(candidate, roundKey, scoreKey) {
      return candidate.numberOfRounds?.includes(roundKey)
        ? candidate[scoreKey] ?? 0
        : "NA";
    },
    formatDateTime(value) {
      if (!value) {
        return "NA";
      }

      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return "NA";
      }

      return date.toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    },
    getDecisionTakenOn(candidate) {
      if (candidate?.status === "SEND_TO_HIRING_MANAGER") {
        return "NA";
      }

      return this.formatDateTime(
        candidate?.decisionGivenOn ||
          candidate?.interviewFinalStatus?.timestamp ||
          candidate?.updatedOn
      );
    },
    getDownloadDateInIST() {
      const today = new Date(
        new Intl.DateTimeFormat("en-US", {
          timeZone: "Asia/Kolkata",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }).format(new Date())
      );
      const dd = String(today.getDate()).padStart(2, "0");
      const mm = String(today.getMonth() + 1).padStart(2, "0");
      const yyyy = today.getFullYear();

      return `${dd}${mm}${yyyy}`;
    },
    downloadCSV(csvData, fileName) {
      const csv = Papa.unparse(csvData);
      const BOM = "\uFEFF";
      const blob = new Blob([BOM + csv], { type: "text/csv;charset=utf-8;" });

      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, fileName);
        return;
      }

      const link = document.createElement("a");
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", fileName);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }
    },
    async downloadCandidates() {
      try {
        this.downloadLoading = true;

        const dataForDownload = this.downloadableCandidates.map(
          (candidate, index) => ({
            "Sr. No": index + 1,
            "Name of the Candidate": candidate.name || "NA",
            Email: candidate.email || "NA",
            Level: candidate.level || "NA",
            "Interview Round": candidate.round ? `Round ${candidate.round}` : "NA",
            Subject: (candidate.subjects || []).join(", ") || "NA",
            "Screening Score": this.formatCandidateRoundScore(
              candidate,
              "screening",
              "screeningTotal"
            ),
            "Mains Score": this.formatCandidateRoundScore(
              candidate,
              "mains",
              "mainsTotal"
            ),
            "Demo Score": this.formatCandidateRoundScore(
              candidate,
              "demo",
              "demoScore"
            ),
            "Interview Score": this.formatCandidateRoundScore(
              candidate,
              "interview",
              "interviewScore"
            ),
            "Status": this.formatCandidateDecisionStatus(candidate.status),
            "Candidate Decision": this.formatCandidateDecision(candidate),
            "Decision Taken On": this.getDecisionTakenOn(candidate),
          })
        );

        const fileName = `candidate_list_${this.getDownloadDateInIST()}.csv`;
        this.downloadCSV(dataForDownload, fileName);
      } catch (error) {
        console.error("Error downloading candidate list:", error);
      } finally {
        this.downloadLoading = false;
      }
    },
    navigateToUserReport(item) {
      this.$router.push({
        name: "CandidateUserReport",
        query: {
          userId: item.userId,
          campaignId: item.campaignId,
          selectedRound: item.round,
          redirectedFrom: 'candidate-list',
        },
      });
    },
    getStatusClass(status) {
      switch (status) {
        case "ACCEPT":
          return {
            class: "accepted-status",
            icon: require("../assets/check-1.svg"),
            statusName: "Accepted",
          };
        case "SCHEDULED":
          return {
            class: "scheduled-status",
            icon: require("../assets/check-1.svg"),
            statusName: "Scheduled",
          };
        case "REJECT":
          return {
            class: "rejected-status",
            icon: require("../assets/close-1.svg"),
            statusName: "Rejected",
          };

        case "ONHOLD":
          return {
            class: "on-hold-status",
            icon: require("../assets/warning-sign.svg"),
            statusName: "On Hold",
          };

        case "SEND_TO_HIRING_MANAGER":
          return {
            class: "hiring-manager-status",
            icon: require("../assets/check-1.svg"),
            statusName: "Sent to Hiring Manager",
          };

        case "NOTIFY_HR":
          return {
            class: "notify-hr-status",
            icon: require("../assets/check-1.svg"),
            statusName: "Notified HR",
          };
      }
    },
    selectSortOption(sortOption) {
      this.selectedSort = sortOption;
      switch (sortOption) {
        case "nameAsc":
          this.sortCol = "name";
          this.sortOrder = "asc";
          break;
        case "nameDesc":
          this.sortCol = "name";
          this.sortOrder = "desc";
          break;
        case "dateNewest":
          this.sortCol = "updatedOn";
          this.sortOrder = "desc";
          break;
        case "dateOldest":
          this.sortCol = "updatedOn";
          this.sortOrder = "asc";
          break;
        default:
          this.selectedSort = "dateNewest";
          this.sortCol = "updatedOn";
          this.sortOrder = "desc";
      }

      this.options.page = 1;
      this.fetchCandidates();
    },
  },
  created() {
    this.fetchCandidates();
  },
};
</script>

<style scoped>
.qpad {
  padding-top: 80px !important;
}
.menuable__content__active {
  z-index: 1034 !important;
  margin: 6px 0px 0px -10px;
  .v-picker {
    .v-picker__body {
      width: 218px !important;
    }
    .v-date-picker-title__date {
      font-size: 24px;
    }
    .v-date-picker-header .v-btn {
      height: 36px !important;
    }
    .v-date-picker-table--date .v-btn {
      height: 26px !important;
      width: 26px;
    }
    .v-date-picker-table {
      height: 190px;
    }
  }
}
.search-bar {
  max-width: 300px;
}
.widened-multi-line-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: auto;
  max-width: 240px;
}
/* Keep column headers on a single line */
.v-data-table ::v-deep thead th {
  white-space: nowrap;
}
.active-chip {
  background-color: primary !important;
  color: white;
}
.decision-not-done-status {
  background: var(--gray-03) !important;
  color: var(--gray-04);
}
.decision-done-status {
  background: var(--success-03) !important;
  color: var(--success-02);
}

/* PLACEHOLDER status colours for the availability flow — tweak to match the
   final design once the status contract is confirmed. */
.invited-status {
  background: #e8e3ff !important;
  color: #6d54e1;
}
.available-status {
  background: #e3f0ff !important;
  color: #2f80ed;
}
.not-available-status {
  background: var(--error-03) !important;
  color: var(--red);
}
.yet-to-decide-status {
  background: var(--gray-03) !important;
  color: var(--gray-04);
}

.availability-radio-group ::v-deep .v-input__control {
  width: auto;
}
.availability-radio-group ::v-deep .v-input--radio-group__input {
  align-items: center;
}
.availability-radio-group ::v-deep .v-radio {
  align-items: center;
  margin-bottom: 0 !important;
}
.availability-radio-group ::v-deep .v-radio .v-label {
  height: auto;
  line-height: 1;
  margin: 0 0 0 4px;
}
/* Make the disabled "No" option read as clearly unavailable */
.availability-radio-group ::v-deep .v-radio--is-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.availability-radio-group ::v-deep .v-radio--is-disabled .v-label {
  color: rgba(0, 0, 0, 0.38) !important;
  cursor: not-allowed;
}
.availability-radio-group ::v-deep .v-radio--is-disabled .v-icon {
  color: rgba(0, 0, 0, 0.26) !important;
}

.candidate-success-popup {
  border-radius: 16px;
}
.candidate-success-popup--text {
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  margin-top: 16px;
}
.v-chip {
  padding: 11px 16px !important;
}

.accepted-status {
  background: var(--success-03) !important;
  color: var(--success-02);
}

.rejected-status {
  background: var(--error-03) !important;
  color: var(--red);
}

.on-hold-status {
  background: var(--light-yellow) !important;
  color: var(--orange);
}

.notify-hr-status {
  background: #efdcf8 !important;
  color: #af52de;
}

.hiring-manager-status {
  background: #e8e3ff !important;
  color: #6d54e1;
}
</style>
